export const DEFAULT_PAGE_SIZE = 10;
export const ADVISOR_OFFSET = 0;
export const CLIENT_OFFSET = 0;
